import { Routes } from '@angular/router';
import { appAuthGuard } from '../_shared/guards/app-auth.guard';
import { assetIQGuard } from '../_shared/guards/beta-user.guard';
import { SettingsComponent } from './settings.component';
import { MaintenanceSettingsComponent } from '../asset-management/settings/maintenance-settings/maintenance-settings.component';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [appAuthGuard, assetIQGuard],
    children: [
      { path: '', redirectTo: 'maintenance-settings', pathMatch: 'full' },
      {
        path: 'general-settings',
        loadComponent: () =>
          import('./general-settings/general-settings.component').then(
            (m) => m.GeneralSettingsComponent
          ),
      },
      { path: 'maintenance-settings', component: MaintenanceSettingsComponent },
      {
        path: 'parts-and-inventory-settings',
        loadComponent: () =>
          import(
            '../asset-management/settings/parts-and-inventory-settings/parts-and-inventory-settings.component'
          ).then((m) => m.PartsAndInventorySettingsComponent),
      },
      {
        path: 'compliance-settings',
        loadComponent: () =>
          import(
            '../asset-management/settings/compliance-settings/compliance-settings.component'
          ).then((m) => m.ComplianceSettingsComponent),
      },
      {
        path: 'cost-tracking-settings',
        loadComponent: () =>
          import(
            '../asset-management/settings/cost-tracking-settings/cost-tracking-settings.component'
          ).then((m) => m.CostTrackingSettingsComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./_shared/components/users/users.component').then(
            (m) => m.UsersComponent
          ),
      },
      {
        path: 'control-tower/events-alerts',
        loadComponent: () =>
          import(
            './control-tower/events-and-alerts/events-and-alerts.component'
          ).then((m) => m.EventsAndAlertsComponent),
      },
      {
        path: 'control-tower/action-center',
        loadComponent: () =>
          import(
            './control-tower/action-center/action-center.component'
          ).then((m) => m.ActionCenterComponent),
      },
      { path: '**', redirectTo: 'maintenance-settings', pathMatch: 'full' },
    ],
  },
];
